import { render } from "./MentorRelationManage.vue?vue&type=template&id=903f0928&scoped=true"
import script from "./MentorRelationManage.vue?vue&type=script&lang=js"
export * from "./MentorRelationManage.vue?vue&type=script&lang=js"

import "./MentorRelationManage.vue?vue&type=style&index=0&id=903f0928&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-903f0928"]])

export default __exports__